import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";

import CustomDescriptionInput from "../UI/PageInput/CustomDescriptionInput";
import GrayButton from "../UI/buttonUI/GrayButton";
import StatusMessage from "./StatusMessage";
import usePostData from "../../CustomHooks/useAxios/usePostData";
import PrimaryButton from "../UI/buttonUI/PrimaryButton";
import {
  setCopyData,
  updateData,
  setSecondCopyData,
} from "../../redux/dataSlice";
import { setFilteredData } from "../../redux/isTableFilterSlice";

const AddRemarkForm = ({
  dataId,
  apiUrl,
  setViewDetails,
  showAddRemark,
  setShowAddRemark,
  setOpenRemarkList,
  currenExpenseTab,
}) => {
  const data = useSelector((state) => state.data.data);
  const copyData = useSelector((state) => state.data.copyData);
  const filteredData = useSelector((state) => state.isTableFilter.filteredData);

  const secondCopyData = useSelector((state) => state.data.secondCopyData);
  const [remarkData, setRemarkData] = useState({ id: dataId, remark: "" });
  const dispatch = useDispatch();
  const {
    executePost,
    loading,
    successResponse,
    formError,
    setSuccessResponse,
  } = usePostData();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    watch((value) => {
      setRemarkData((prev) => {
        return { ...prev, ...value };
      });
    });
  }, [watch]);

  const updateStateOnResponse = () => {
    setRemarkData({ id: dataId, remark: "" });
    setShowAddRemark(false);
    setOpenRemarkList(true);
    // reset form value
    reset();
  };

  const clearForm = () => {
    setRemarkData({ id: dataId, remark: "" });
    reset();
  };

  const onSubmit = () => {
    //API calling
    executePost(remarkData, apiUrl, updateStateOnResponse);
  };

  useEffect(() => {
    if (!successResponse) return;

    const timeoutId = setTimeout(() => {
      setSuccessResponse(null);
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [successResponse]);

  // expense view dialog list updated when remark successfully added
  useEffect(() => {
    if (successResponse) {
      setViewDetails({ open: true, data: successResponse });
      const updateArrayWithRemark = (array) =>
        array.map((item) =>
          item.id === successResponse.id ? successResponse : item,
        );

      const updatedData = updateArrayWithRemark(data);
      const updatedCopyData = updateArrayWithRemark(copyData);
      const updatedFilteredData = updateArrayWithRemark(filteredData);
      if (currenExpenseTab) {
        const updatedCategorizedExpenses = {
          ...secondCopyData,
          [currenExpenseTab]: updatedCopyData,
        };
        dispatch(setSecondCopyData(updatedCategorizedExpenses));
      }
      dispatch(updateData(updatedData));
      dispatch(setFilteredData(updatedFilteredData));
      dispatch(setCopyData(updatedCopyData));
    }
  }, [successResponse]);

  return (
    <>
      <StatusMessage isSucceed={successResponse} formError={formError} />
      {showAddRemark ? (
        <div className="remark-form-wrap">
          <form>
            <CustomDescriptionInput
              name="remark"
              labelText="Remark *"
              register={{
                ...register("remark", {
                  required: "Please Enter Remark",
                }),
              }}
              error={errors.remark}
            />
          </form>
          <div className="remark-form-btn-wrap">
            <p className="pr-1 2xs:max-sm:pr-1">
              <PrimaryButton
                btnText={!loading ? "Add Remark" : "Adding..."}
                onClick={!loading ? handleSubmit(onSubmit) : undefined}
                loading={loading}
                textSize="text-xs"
              />
            </p>
            <p className="pl-1 h-full 2xs:max-sm:pl-1">
              <GrayButton
                btnText="Clear"
                textSize="text-xs"
                onClick={clearForm}
              />
            </p>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
export default AddRemarkForm;
